import { datadogRum } from '@datadog/browser-rum'

/**
 * Pull external user ID (`tc` param) from URL and store in session storage.
 * Used to associate unauthenticated page visits with a known user.
 * Passed to events service and Datadog.
 */
export function storeExternalUserId() {
  const params = new URLSearchParams(window.location.search)
  const tc = params.get('tc')

  if (tc) {
    window.sessionStorage.setItem('tc', tc)
  }

  const storedTc = window.sessionStorage.getItem('tc')
  if (storedTc) {
    datadogRum.setGlobalContextProperty('externalUserId', storedTc)
  }
}

/**
 * Get external user ID from session storage
 */
export function getExternalUserIdFromSessionStorage() {
  return {
    externalUserId: window.sessionStorage.getItem('tc'),
  }
}
